import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  CollectionAssetsQuery,
  CollectionAssetsQueryResult,
} from "../../../generated/gql/graphql";

const GET_COLLECTION_ASSETS = gql`
  query GetCollectionAssets(
    $collectionId: String!
    $query: CollectionAssetsQuery
  ) {
    collectionAssets(collectionId: $collectionId, query: $query) {
      items {
        id
        approval
        status
        sort
        type
        name
        image
        parentId
        categoryId
        nextAssetId
        prevAssetId
        contentAmount
        contentUnit
        favorite
        geometry
        metashotsType
        # languageRegionsId
        assetTypes
        brandId
        collectionId
        oderIndex
        dateCreated
        dateUpdated
      }
      limit
      offset
      page
      totalCount
    }
  }
`;

export default function useCollectionAssets(
  collectionId: string,
  query?: CollectionAssetsQuery
): QueryResult<{ collectionAssets: CollectionAssetsQueryResult }> {
  return useQuery(GET_COLLECTION_ASSETS, {
    variables: {
      collectionId,
      query,
    },
  });
}
